export default __webpack_public_path__ + "thin-arrowheads-pointing-down.png";